import { ArticleAny } from "@/types"
import { UserPermission } from "config/constants"
import Asset from "models/Asset"

/**
 * Whether the copy action may be offered for an asset.
 *
 * Copying needs both `AssetCreate` — copies are created through the regular
 * create endpoint — and `AssetFinancialView`, because the copy dialog prefills
 * and carries over the source's financial data (reference numbers, reference
 * value, asset category/type/product, monthly rental cost, list price). Without
 * the financial permission that block is unreadable and the copies would come
 * out incomplete, so the action is hidden rather than degraded.
 *
 * Only the current version of an asset can be copied; a historical version is
 * read-only, mirroring the edit action.
 */
export default function canCopyAsset(
    asset: Asset | null | undefined,
    article: ArticleAny | null | undefined,
    hasPermission: (permission: UserPermission) => boolean,
): boolean {
    if (!asset || !article) return false
    if (!asset.isCurrentVersion) return false

    return hasPermission(UserPermission.AssetCreate)
        && hasPermission(UserPermission.AssetFinancialView)
}
